export abstract class _MasterPage { }



// WEBPACK FOOTER //
// ./src/pages/_MasterPage.ts